
window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.suprimentos = window.FazendaRP.Pages.suprimentos || {};

window.FazendaRP.Pages.suprimentos.dashboard = {
    charts: {}, // Store charts to destroy them on re-render

    render: function () {
        return `
            <div id="sup-dashboard-container" style="max-width: 1400px; margin: 0 auto; animation: fadeIn 0.3s;">
                
                <div style="margin-bottom: 25px; display: flex; justify-content: space-between; align-items: center;">
                    <div>
                        <h2 style="margin: 0; font-size: 1.5rem; color: #1f2937;">Inteligência de Suprimentos</h2>
                        <p style="margin: 5px 0 0; color: #6b7280; font-size: 0.9rem;">Foco em eficiência de compras e redução de estoque.</p>
                    </div>
                    <div>
                         <select id="dash-year-filter" style="padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 6px; font-size: 0.9rem; color: #374151;">
                            <option value="2025" selected>2025</option>
                            <option value="2024">2024</option>
                         </select>
                    </div>
                </div>

                <!-- ROW 1: KPIs -->
                <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 25px;">
                    
                    <!-- KPI 1: Capital Parado -->
                    <div class="card" style="background:white; padding:20px; border-radius:12px; border-left: 5px solid #f59e0b; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <div style="font-size: 0.85rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Capital em Estoque (Imobilizado)</div>
                        <div id="kpi-capital-stock" style="font-size: 2rem; font-weight: 700; color: #111827; margin: 10px 0 5px;">R$ ...</div>
                        <div style="font-size: 0.8rem; display: flex; align-items: center; gap: 5px;">
                            <span style="background: #fffbeb; color: #b45309; padding: 2px 6px; border-radius: 4px; font-weight:600;">Meta: Zero</span>
                        </div>
                    </div>

                    <!-- KPI 2: Total Comprado -->
                    <div class="card" style="background:white; padding:20px; border-radius:12px; border-left: 5px solid #3b82f6; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <div style="font-size: 0.85rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Total Comprado (Ano)</div>
                        <div id="kpi-total-bought" style="font-size: 2rem; font-weight: 700; color: #111827; margin: 10px 0 5px;">R$ ...</div>
                        <div id="kpi-total-bought-sub" style="font-size: 0.8rem; color: #9ca3af;">Calculando...</div>
                    </div>

                    <!-- KPI 3: Estoque Morto -->
                    <div class="card" style="background:white; padding:20px; border-radius:12px; border-left: 5px solid #ef4444; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <div style="font-size: 0.85rem; color: #6b7280; font-weight: 500; text-transform: uppercase;">Itens sem Giro (>90 dias)</div>
                        <div id="kpi-dead-stock-count" style="font-size: 2rem; font-weight: 700; color: #ef4444; margin: 10px 0 5px;">...</div>
                        <div id="kpi-dead-stock-val" style="font-size: 0.8rem; color: #374151; font-weight: 600;">R$ ... parados</div>
                    </div>

                </div>

                <!-- ROW 2: Charts -->
                <div style="display: grid; grid-template-columns: 2fr 1fr; gap: 20px; margin-bottom: 25px;">
                    
                    <!-- Esquerda: Top Fornecedores -->
                    <div class="card" style="background:white; padding:20px; border-radius:12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <div style="display:flex; justify-content:space-between; margin-bottom:15px;">
                            <h3 style="margin:0; font-size:1rem; color:#374151;"><i class="fas fa-handshake"></i> Top 5 Fornecedores (Valor)</h3>
                        </div>
                        
                        <div style="height: 250px; width: 100%;">
                            <canvas id="chartSuppliers"></canvas>
                        </div>
                    </div>

                    <!-- Direita: Curva ABC (Pareto) -->
                    <div class="card" style="background:white; padding:20px; border-radius:12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <div style="margin-bottom:15px;">
                            <h3 style="margin:0; font-size:1rem; color:#374151;"><i class="fas fa-chart-pie"></i> Curva ABC (Categorias)</h3>
                        </div>
                        <div style="height: 220px; width: 100%; position: relative;">
                            <canvas id="chartABC"></canvas>
                        </div>
                        <div id="abc-diagnosis" style="margin-top:15px; border-top:1px solid #f1f5f9; padding-top:10px; display:none; max-height:200px; overflow-y:auto;"></div>
                    </div>

                </div>

                <!-- ROW 3: Tables -->
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
                    
                    <!-- Tabela: Capital Adormecido -->
                    <div class="card" style="background:white; padding:20px; border-radius:12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <div style="margin-bottom:15px; border-bottom:1px solid #eee; padding-bottom:10px;">
                            <h3 style="margin:0; font-size:1rem; color:#374151;"><i class="fas fa-bed"></i> "Dinheiro Dormindo" (Estoque sem Giro)</h3>
                        </div>
                        <div style="overflow-x:auto;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                <thead>
                                    <tr style="color:#6b7280; font-size:0.8rem; text-transform:uppercase;">
                                        <th style="text-align:left; padding:8px;">Item</th>
                                        <th style="text-align:right; padding:8px;">Valor Parado</th>
                                        <th style="text-align:right; padding:8px;">Dias Parado</th>
                                    </tr>
                                </thead>
                                <tbody id="table-dead-stock">
                                    <tr><td colspan="3" style="text-align:center; padding:20px; color:#ccc;"><i class="fas fa-spinner fa-spin"></i></td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Tabela: Variação de Preço -->
                    <div class="card" style="background:white; padding:20px; border-radius:12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                        <div style="margin-bottom:15px; border-bottom:1px solid #eee; padding-bottom:10px;">
                            <h3 style="margin:0; font-size:1rem; color:#374151;"><i class="fas fa-trending-up"></i> Alerta de Preço (Últimas Compras)</h3>
                        </div>
                        <div style="overflow-x:auto;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 0.9rem;">
                                <thead>
                                    <tr style="color:#6b7280; font-size:0.8rem; text-transform:uppercase;">
                                        <th style="text-align:left; padding:8px;">Item</th>
                                        <th style="text-align:right; padding:8px;">Pago vs Médio</th>
                                        <th style="text-align:right; padding:8px;">Variação</th>
                                    </tr>
                                </thead>
                                <tbody id="table-price-alerts">
                                    <tr><td colspan="3" style="text-align:center; padding:20px; color:#ccc;"><i class="fas fa-spinner fa-spin"></i></td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        `;
    },

    autoSelectYear: async function () {
        // CORREÇÃO: Forçar 2025 ou Ano Atual, independente do banco
        const currentYear = new Date().getFullYear();
        const select = document.getElementById('dash-year-filter');

        if (select) {
            // Se a opção do ano atual não existir, cria
            if (!select.querySelector(`option[value="${currentYear}"]`)) {
                const opt = document.createElement('option');
                opt.value = currentYear;
                opt.innerText = currentYear;
                select.appendChild(opt);
            }
            // Seleciona o ano atual por padrão
            select.value = currentYear;
        }
    },

    init: async function () {
        await this.autoSelectYear();

        // CORREÇÃO: Destruir gráficos antigos antes de recriar (evita erro de Canvas)
        if (this.charts.suppliers) this.charts.suppliers.destroy();
        if (this.charts.abc) this.charts.abc.destroy();

        // Initial Data Loads
        const year = document.getElementById('dash-year-filter').value;
        try {
            await Promise.all([
                this.loadFinancialMetrics(year),
                this.loadStockMetrics(),
                this.loadDeadStock(),
                this.loadPriceAlerts()
            ]);
        } catch (e) {
            console.error("Critical Error loading Dashboard:", e);
            const errEl = document.getElementById('kpi-total-bought-sub');
            if (errEl) errEl.innerText = "Erro ao carregar: " + e.message;
        }

        // Listener for year change
        const yearFilter = document.getElementById('dash-year-filter');
        if (yearFilter) {
            yearFilter.addEventListener('change', (e) => {
                this.loadFinancialMetrics(e.target.value);
            });
        }
    },

    categories: [], // Cache for categories

    // Load categories tree (Once)
    loadCategories: async function () {
        if (this.categories.length > 0) return;

        const { data, error } = await window.FazendaRP.supabase
            .from('suprimentos_itens')
            .select('id, nome, parent_id, tipo')
            .eq('tipo', 'CATEGORIA');

        if (data) this.categories = data;
    },

    // Helper to find Root Category Name for an Item ID
    // Strategy: Fetch Item -> Get Parent -> Get Parent... until Root or Category found
    // Optimization: Since we don't have all ITEMS loaded, we will fetch necessary items in batch during metrics load.
    // Here we just map Category ID -> Root Category Name
    getRootCategoryValues: function (categoryId) {
        if (!categoryId) return 'Outros';

        let current = this.categories.find(c => c.id === categoryId);
        if (!current) return 'Outros';

        // Traverse up to find a broad group?
        // Or just let the breakdown be by immediate category?
        // User asked for "Hierarquia". Let's show the Name of the Category linked to the item.
        // If that category has a parent, maybe show Parent > Child?
        // For chart simplicity, let's show the DIRECT Category of the item.
        return current.nome;
    },

    loadFinancialMetrics: async function (year) {
        // 1. Ensure Categories are loaded
        await this.loadCategories();

        const start = `${year}-01-01`;
        const end = `${year}-12-31`;

        // CORREÇÃO: Fetch ALL records using pagination (Supabase often limits to 1000)
        let allLancamentos = [];
        let page = 0;
        const pageSize = 1000;
        let fetchMore = true;

        while (fetchMore) {
            const { data: batch, error } = await window.FazendaRP.supabase
                .from('financeiro_lancamentos')
                .select('id, valor, parceiro_id, detalhes, tipo, data_emissao, status, conta_id, parceiros(nome)')
                .eq('tipo', 'Despesa')
                .gte('data_emissao', start)
                .lte('data_emissao', end)
                .neq('status', 'Cancelado')
                .range(page * pageSize, (page + 1) * pageSize - 1);

            if (error) {
                console.error(error);
                const sub = document.getElementById('kpi-total-bought-sub');
                if (sub) sub.innerText = `Erro SQL: ${error.message}`;
                return;
            }

            if (batch.length > 0) {
                allLancamentos = allLancamentos.concat(batch);
                if (batch.length < pageSize) fetchMore = false; // End of list
                page++;
            } else {
                fetchMore = false;
            }
        }

        const lancamentos = allLancamentos;



        let totalBought = 0;
        const supplierMap = {};
        const categoryMap = {};

        // Fetch Financial Accounts for Fallback
        // Fetch Account Names & Codes for Fallback
        const { data: accounts } = await window.FazendaRP.supabase
            .from('financeiro_plano_contas')
            .select('id, nome, codigo');

        const accountMap = {};
        if (accounts) {
            accounts.forEach(a => accountMap[a.id] = { nome: a.nome, codigo: a.codigo });
        }
        const outrosItemsMap = {}; // Diagnosis

        // Collect all Item IDs to fetch their parent_id (Category)
        const itemIdsToFetch = new Set();
        lancamentos.forEach(l => {
            if (typeof l.detalhes === 'string') try { l.detalhes = JSON.parse(l.detalhes); } catch (e) { }
            if (l.detalhes && l.detalhes.itens) {
                l.detalhes.itens.forEach(i => {
                    if (i.id) itemIdsToFetch.add(i.id);
                });
            }
        });

        // Batch fetch Item Definitions to get their Categories (parent_id)
        let itemCategoryMap = {};
        if (itemIdsToFetch.size > 0) {
            const { data: items } = await window.FazendaRP.supabase
                .from('suprimentos_itens')
                .select('id, parent_id, contas')
                .in('id', Array.from(itemIdsToFetch));

            if (items) {
                // itemCategoryMap now maps ID -> { parentId, contas }
                items.forEach(i => itemCategoryMap[i.id] = {
                    parentId: i.parent_id,
                    contas: i.contas
                });
            }
        }

        // Process Data
        lancamentos.forEach(l => {
            // 1. ALWAYS Count Total and Supplier (Independent of Item Details)
            const val = parseFloat(l.valor || 0);
            // NEW: Strict Supply Filter
            const accObj = l.conta_id && accountMap[l.conta_id] ? accountMap[l.conta_id] : null;
            const accCode = accObj ? (accObj.codigo || '') : '';
            const accName = accObj ? (accObj.nome || '') : '';

            // 1. If has Account, MUST be '2.1' (Insumos)
            // CHECK BOTH CODE AND NAME (Some accounts might have empty code but name "2.1.x - ...")
            if (accObj && !accCode.startsWith('2.1') && !accName.startsWith('2.1')) {
                return;
            }

            // 2. If NO Account, and NO Items (Direct Entry), we assume it's NOT a supply (e.g. Withdrawals, Labor)
            // Because if it were a supply, it should either have items or be categorized.
            // This cleans up the "Outros" chart from "unknown" financial entries.
            let hasItems = false;
            if (l.detalhes) {
                // Handle different details formats (string/object)
                const det = typeof l.detalhes === 'string' ? JSON.parse(l.detalhes) : l.detalhes;
                if (det && Array.isArray(det.itens) && det.itens.length > 0) hasItems = true;
            }

            if (!l.conta_id && !hasItems) {
                return;
            }

            totalBought += val;

            const pName = l.parceiros?.nome || 'Fornecedor Desconhecido';
            supplierMap[pName] = (supplierMap[pName] || 0) + val;

            // 2. Count Categories ONLY if Items exist
            if (l.detalhes && l.detalhes.itens && Array.isArray(l.detalhes.itens) && l.detalhes.itens.length > 0) {
                l.detalhes.itens.forEach(item => {
                    const iTotal = parseFloat(item.total || 0);

                    // Resolve Category
                    const itemDef = itemCategoryMap[item.id] || {};
                    const prodCatId = itemDef.parentId;
                    let prodCatName = this.getRootCategoryValues(prodCatId);

                    let catName = 'Outros';

                    // PRIORITY 1: Financial Account (Transaction Level)
                    if (l.conta_id && accountMap[l.conta_id]) {
                        catName = accountMap[l.conta_id].nome; // Use .nome from object
                    }
                    // PRIORITY 2: Product Default Account (Item Level) - NEW
                    else if (itemDef.contas && Array.isArray(itemDef.contas) && itemDef.contas.length > 0) {
                        catName = itemDef.contas[0];
                    }
                    // PRIORITY 3: Product Category
                    else if (prodCatName && prodCatName !== 'Outros') {
                        catName = prodCatName;
                    }
                    // Final Fallback remains 'Outros'

                    categoryMap[catName] = (categoryMap[catName] || 0) + iTotal;

                    // Diagnosis: Collect items landing in 'Outros'
                    if (catName === 'Outros') {
                        let reason = 'Desconhecido';
                        if (!item.id) reason = 'Item Avulso (Não vinculado ao cadastro)';
                        else if (!itemDef.parentId && (!itemDef.contas || itemDef.contas.length === 0)) reason = 'Cadastro incompleto (Sem Categoria/Conta)';
                        else if (prodCatId === undefined) reason = 'Item não encontrado (Excluído?)';
                        else reason = `Categoria não encontrada (ID: ${prodCatId}). Sem vínculo contábil.`;

                        const key = `${item.nome || 'Item Sem Nome'}||${reason}`;
                        outrosItemsMap[key] = (outrosItemsMap[key] || 0) + iTotal;
                    }
                });
            } else {
                // Non-itemized expenses: Try to use Financial Account
                // IMPORTANT: Only include if it's a SUPPLY account (2.1.x), not other categories
                let catName = 'Outros / Não Categorizado';
                let categorized = false;

                if (l.conta_id && accountMap[l.conta_id]) {
                    const acc = accountMap[l.conta_id];
                    const accCode = acc.codigo || '';
                    const accName = acc.nome || '';

                    // Only categorize if it's a supply account (2.1)
                    // This prevents pro-labore, withdrawals, etc. from appearing here
                    if (accCode.startsWith('2.1') || accName.startsWith('2.1')) {
                        catName = acc.nome; // Use .nome
                        categorized = true;
                    }
                }

                // ONLY add to categoryMap if categorized as supply
                if (categorized) {
                    categoryMap[catName] = (categoryMap[catName] || 0) + val;
                }

                // Diagnosis: Track items that didn't make it
                if (!categorized) {
                    const reason = 'Lançamento sem Itens e sem Conta de Insumos (2.1.x)';
                    const pName = l.parceiros?.nome || 'Fornecedor Desconhecido';
                    const desc = l.descricao || 'Sem Descrição';
                    const key = `${pName} - ${desc} (ID: ${l.id})||${reason}`;
                    // Don't add to outrosItemsMap - these aren't supplies at all, just skip them
                }
            }
        });

        const elTotal = document.getElementById('kpi-total-bought');
        if (elTotal) elTotal.innerText = totalBought.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

        const elTotalSub = document.getElementById('kpi-total-bought-sub');
        if (elTotalSub) elTotalSub.innerText = `Referente a ${year} (Emissão)`;

        this.renderSupplierChart(supplierMap);
        this.renderSupplierChart(supplierMap);
        this.renderABCChart(categoryMap);

        // Diagnosis for 'Outros'
        this.renderOutrosDiagnosis(outrosItemsMap);
    },

    renderOutrosDiagnosis: function (map) {
        const container = document.getElementById('abc-diagnosis');
        if (!container) return;

        const entries = Object.entries(map).sort((a, b) => b[1] - a[1]);

        container.style.display = 'block';

        if (entries.length === 0) {
            container.innerHTML = `
                <div style="padding:15px; text-align:center; background:#f0fdf4; border:1px solid #bbf7d0; border-radius:8px; color:#166534;">
                    <i class="fas fa-check-circle"></i> <b>Excelente!</b><br>
                    Todos os itens foram categorizados corretamente.
                </div>
            `;
            return;
        }
        const top5 = entries.slice(0, 5);

        container.innerHTML = `
            <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:5px;">
                <div style="font-size:0.75rem; font-weight:600; color:#ef4444;">⚠️ O que é "Outros"? (Detalhes)</div>
                <button id="btn-export-outros" style="background:white; border:1px solid #ef4444; color:#ef4444; border-radius:4px; cursor:pointer; font-size:0.75rem; padding:4px 8px; font-weight:600;">
                    <i class="fas fa-file-csv"></i> Baixar Planilha
                </button>
            </div>
            <table style="width:100%; font-size:0.75rem;">
                ${top5.map(e => {
            const [name, reason] = e[0].split('||');
            return `
                    <tr>
                        <td style="color:#334155;">
                            <b>${name}</b><br>
                            <span style="color:#94a3b8; font-size:0.7rem;">${reason}</span>
                        </td>
                        <td style="text-align:right; font-weight:bold; vertical-align:top;">${e[1].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                    </tr>
                `}).join('')}
                ${entries.length > 5 ? `<tr><td colspan="2" style="text-align:center; color:#94a3b8; padding-top:4px;">+ ${entries.length - 5} outros itens... (Use o botão p/ ver todos)</td></tr>` : ''}
            </table>
        `;

        const btn = document.getElementById('btn-export-outros');
        if (btn) btn.onclick = () => this.downloadOutrosCSV(entries);
    },

    downloadOutrosCSV: function (entries) {
        let csvContent = "data:text/csv;charset=utf-8,\uFEFFItem;Motivo;Valor Total\n";
        entries.forEach(e => {
            const parts = e[0].split('||');
            const name = parts[0] || 'Unknown';
            const reason = parts[1] || 'Unknown';
            // Simple CSV escaping
            const safeName = name.replace(/"/g, '""');
            const safeReason = reason.replace(/"/g, '""');
            const val = e[1].toFixed(2).replace('.', ',');

            csvContent += `"${safeName}";"${safeReason}";"${val}"\n`;
        });

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "Items_Sem_Categoria.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },

    renderSupplierChart: function (map) {
        const sorted = Object.entries(map).sort((a, b) => b[1] - a[1]).slice(0, 5); // Top 5
        const ctx = document.getElementById('chartSuppliers');
        if (!ctx) return;

        // CORREÇÃO: Limpar chart anterior
        if (this.charts.suppliers) this.charts.suppliers.destroy();

        this.charts.suppliers = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: sorted.map(x => x[0]),
                datasets: [{
                    label: 'Valor (R$)',
                    data: sorted.map(x => x[1]),
                    backgroundColor: ['#059669', '#10b981', '#34d399', '#6ee7b7', '#d1fae5'],
                    borderRadius: 5
                }]
            },
            options: {
                indexAxis: 'y',
                maintainAspectRatio: false,
                plugins: { legend: { display: false } },
                scales: {
                    x: { grid: { display: false }, ticks: { callback: (v) => 'R$ ' + v / 1000 + 'k' } },
                    y: { grid: { display: false } }
                }
            }
        });
    },

    renderABCChart: function (map) {
        const sorted = Object.entries(map).sort((a, b) => b[1] - a[1]);
        const ctx = document.getElementById('chartABC');
        if (!ctx) return;

        // CORREÇÃO: Limpar chart anterior
        if (this.charts.abc) this.charts.abc.destroy();

        this.charts.abc = new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: sorted.map(x => x[0]),
                datasets: [{
                    data: sorted.map(x => x[1]),
                    backgroundColor: ['#0f172a', '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#cbd5e1'],
                    borderWidth: 0
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { position: 'right', labels: { usePointStyle: true, boxWidth: 8 } }
                },
                cutout: '65%'
            }
        });
    },

    loadStockMetrics: async function () {
        // Fetch current stock value
        const { data: stock, error } = await window.FazendaRP.supabase
            .from('suprimentos_estoque')
            .select('saldo_atual, custo_medio');

        if (stock) {
            let totalVal = 0;
            stock.forEach(s => {
                const qtd = parseFloat(s.saldo_atual || 0);
                const custo = parseFloat(s.custo_medio || 0);
                if (qtd > 0) totalVal += (qtd * custo);
            });
            const el = document.getElementById('kpi-capital-stock');
            if (el) el.innerText = totalVal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        }
    },

    loadDeadStock: async function () {
        // Difficult: We need "Last Exit Date". Not in 'suprimentos_estoque'.
        // We need to query 'suprimentos_movimentacoes' max(created_at) where tipo='SAIDA' group by item.
        // Or fetch stock items and for each > 0, fetch last movement.

        // Simplified approach: Fetch stock items > 0.
        // Then fetch their last movement.

        const { data: stock } = await window.FazendaRP.supabase
            .from('suprimentos_estoque')
            .select('id, item_nome, saldo_atual, custo_medio, unidade')
            .gt('saldo_atual', 0)
            .order('saldo_atual', { ascending: false }); // High value first?

        if (!stock || stock.length === 0) {
            const elCount = document.getElementById('kpi-dead-stock-count');
            if (elCount) elCount.innerText = "0";

            const tbody = document.getElementById('table-dead-stock');
            if (tbody) tbody.innerHTML = '<tr><td colspan="3" style="padding:15px; text-align:center;">Estoque Zero/Limpo! Parabéns.</td></tr>';
            return;
        }

        // Filter for dead stock (> 90 days NO OUTPUT)
        // Optimization: We can't do this efficiently without a View or complex query. 
        // Client-side: Iterate top 50 valuable items and check last movement.

        const deadItems = [];
        const ninetyDaysAgo = new Date();
        ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);

        // Sort by Total Value to prioritize check
        const valuedStock = stock.map(s => ({
            ...s,
            totalVal: s.saldo_atual * s.custo_medio
        })).sort((a, b) => b.totalVal - a.totalVal);

        let deadCount = 0;
        let deadValue = 0;

        // Check top 20 items (Heuristic)
        // In full prod we would need a better backend query
        for (const item of valuedStock.slice(0, 50)) {
            const { data: movs } = await window.FazendaRP.supabase
                .from('suprimentos_movimentacoes')
                .select('created_at')
                .eq('estoque_id', item.id)
                // .eq('tipo', 'SAIDA') // REMOVED: Check ANY movement (Entry or Exit) to determine activity
                .order('created_at', { ascending: false })
                .limit(1);

            let lastDate = null;
            if (movs && movs.length > 0) {
                lastDate = new Date(movs[0].created_at);
            } else {
                // Never moved? (Rare if it has stock, means initial load without mov?)
                lastDate = new Date('2000-01-01');
            }

            if (lastDate < ninetyDaysAgo) {
                deadCount++;
                deadValue += item.totalVal;

                // Days ago
                const days = Math.floor((new Date() - lastDate) / (1000 * 60 * 60 * 24));
                const label = days > 5000 ? 'Sem mov.' : `${days} dias`;

                deadItems.push({ ...item, days: label });
            }
        }

        const elCount = document.getElementById('kpi-dead-stock-count');
        const elVal = document.getElementById('kpi-dead-stock-val');
        if (elCount) elCount.innerText = deadCount;
        if (elVal) elVal.innerText = deadValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + ' parados';

        // Render Table (Top 5)
        const tbody = document.getElementById('table-dead-stock');
        if (tbody) {
            tbody.innerHTML = deadItems.slice(0, 5).map(i => `
            <tr style="border-bottom:1px solid #f3f4f6;">
                <td style="padding:10px;">
                    <div style="font-weight:600; color:#374151;">${i.item_nome}</div>
                    <div style="font-size:0.75rem; color:#9ca3af;">${parseFloat(i.saldo_atual).toFixed(2)} ${i.unidade}</div>
                </td>
                <td style="padding:10px; text-align:right; font-weight:600; color:#ef4444;">${i.totalVal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                <td style="padding:10px; text-align:right; color:#6b7280;">${i.days}</td>
            </tr>
        `).join('');
        }

        if (deadItems.length === 0 && tbody) {
            tbody.innerHTML = '<tr><td colspan="3" style="padding:15px; text-align:center; color:#10b981;">Nenhum item estagnado encontrado nos top valores.</td></tr>';
        }
    },

    loadPriceAlerts: async function () {
        // Logic: Fetch last Purchase for items. Compare with Avg Cost.
        // Just checking top recent purchases.
        // CORREÇÃO: Usar data_emissao para ordenar ou data_vencimento? Emissao faz sentido para histórico de preço
        const { data: purchases } = await window.FazendaRP.supabase
            .from('financeiro_lancamentos')
            .select('detalhes')
            .eq('tipo', 'Despesa')
            .neq('status', 'Cancelado')
            .order('data_emissao', { ascending: false }) // Mudado para data_emissao
            .limit(20);

        const alerts = [];
        // Flatten items from purchases
        if (purchases) {
            purchases.forEach(p => {
                if (typeof p.detalhes === 'string') try { p.detalhes = JSON.parse(p.detalhes); } catch (e) { }
                if (p.detalhes && p.detalhes.itens) {
                    p.detalhes.itens.forEach(i => {
                        if (i.id && i.valor_unitario) {
                            // Need current avg cost to compare. 
                            // Optimized: Just adding candidate, will resolve Metric later? 
                            // Better: Only checking specific high-interest items or generic check
                            alerts.push({
                                id: i.id,
                                nome: i.nome,
                                pago: parseFloat(i.valor_unitario),
                                // We don't have stored AVG cost here easily without fetching stock for each.
                            });
                        }
                    })
                }
            })
        }

        // For simplicity/performance: Just clean the table for now or mock it until we have robust 'Preço Médio' map available
        // Real implementation requires fetching stock data for these items to get 'custo_medio'.
        // Let's do it for unique items found.
        const uniqueIds = [...new Set(alerts.map(a => a.id))].filter(x => x);
        const verifiedAlerts = [];

        if (uniqueIds.length > 0) {
            const { data: stocks } = await window.FazendaRP.supabase
                .from('suprimentos_estoque')
                .select('item_id, custo_medio')
                .in('item_id', uniqueIds);

            const costMap = {};
            if (stocks) stocks.forEach(s => costMap[s.item_id] = s.custo_medio);

            alerts.forEach(a => {
                const avg = costMap[a.id];
                if (avg && avg > 0) {
                    const diff = ((a.pago - avg) / avg) * 100;
                    if (Math.abs(diff) > 5) { // Only showing > 5% variation
                        verifiedAlerts.push({ ...a, avg, diff });
                        verifiedAlerts.push({ ...a, avg, diff });
                    }
                }
            });
        }

        // Render (Always run this to clear spinner)
        const tbody = document.getElementById('table-price-alerts');
        if (!tbody) return;

        if (verifiedAlerts.length > 0) {
            // Dedupe if needed or just slice
            // Dedupe verifiedAlerts by id? Or allow history? Allow history is fine.
            const uniqueHistory = [];
            // Simple dupe check by item name just to avoid spam
            const seen = new Set();
            verifiedAlerts.forEach(a => {
                if (!seen.has(a.nome + a.pago)) {
                    uniqueHistory.push(a);
                    seen.add(a.nome + a.pago);
                }
            });

            tbody.innerHTML = uniqueHistory.slice(0, 5).map(a => `
                <tr style="border-bottom:1px solid #f3f4f6;">
                    <td style="padding:10px; font-weight:600; color:#374151;">${a.nome}</td>
                    <td style="padding:10px; text-align:right;">
                        <div style="font-size:0.85rem;">Pago: R$ ${a.pago.toFixed(2)}</div>
                        <div style="font-size:0.75rem; color:#9ca3af;">Méd: R$ ${a.avg.toFixed(2)}</div>
                    </td>
                    <td style="padding:10px; text-align:right;">
                        <span style="background:${a.diff > 0 ? '#fef2f2' : '#f0fdf4'}; color:${a.diff > 0 ? '#ef4444' : '#166534'}; padding:2px 6px; border-radius:4px; font-weight:700; font-size:0.8rem;">
                            ${a.diff > 0 ? '+' : ''}${a.diff.toFixed(1)}%
                        </span>
                    </td>
                </tr>
            `).join('');
        } else {
            tbody.innerHTML = '<tr><td colspan="3" style="text-align:center; padding:15px; color:#6b7280;">Nenhuma variação relevante recente.</td></tr>';
        }
    }
};
